import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, of } from 'rxjs'
import { Backend } from 'src/app/shared/enums/enums'
import { DdcLoggerService } from '../log/ddc-logger.service'

@Injectable({
  providedIn: 'root',
})
export class NoteService {
  constructor(
    private http: HttpClient,
    private logger: DdcLoggerService,
  ) {}

  get_notes(): any {
    this.logger.info('NOTE | get_notes')
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http.get(`${Backend.HOST_CONTAINER + Backend.NOTE}`, httpOptions).pipe(
      map((res: any) => {
        return res.results
      }),
      catchError((error: any) => {
        const errorMessage = error.error
        this.logger.error('NOTE | get_notes | catchError | errorMessage: ' + errorMessage)
        return of(errorMessage)
      }),
    )
  }

  get_notes_page(page: number, pageSize: number): any {
    this.logger.info('NOTE | get_notes_page | page: ' + page + ' | pageSize: ' + pageSize)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(
        `${Backend.HOST_CONTAINER + Backend.NOTE}?page=${page}&pageSize=${pageSize}`,
        httpOptions,
      )
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('NOTE | get_notes_page | catchError | errorMessage: ' + errorMessage)
          return of(errorMessage)
        }),
      )
  }

  get_searched_notes(target: string): any {
    this.logger.info('NOTE/Search | get_searched_notes | target: ' + target)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(`${Backend.HOST_CONTAINER + Backend.NOTE}search/?label=${target}`, httpOptions)
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'NOTE/Search | get_searched_notes | catchError | errorMessage: ' + errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  get_pub_searched_notes(target: string): any {
    this.logger.info('NOTE/Search All | get_pub_searched_notes | target: ' + target)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(`${Backend.HOST_CONTAINER + Backend.NOTE}search/?all=true&label=${target}`, httpOptions)
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'NOTE/Search All | get_pub_searched_notes | catchError | errorMessage: ' + errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  add_note(title: string, text?: string, privacy?: string): any {
    this.logger.info('NOTE | add_note | title: ' + title)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    const userData: any = {
      title: title,
    }
    if (text) {
      userData.text = text
    }
    if (privacy) {
      userData.privacy = privacy
    }

    return this.http.post(`${Backend.HOST_CONTAINER + Backend.NOTE}`, userData, httpOptions).pipe(
      map((res: any) => {
        return { success: true, res: res }
      }),
      catchError((error: any) => {
        const errorMessage = error.error
        this.logger.error('NOTE | add_note | catchError | errorMessage: ' + errorMessage)
        return of({ success: false, res: errorMessage })
      }),
    )
  }

  get_user_notes_page(username: string, page: number, pageSize: number): any {
    this.logger.info('NOTE | get_user_notes_page | username: ' + username + ' | page: ' + page)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(
        `${Backend.HOST_CONTAINER + Backend.NOTE}?username=${username}&page=${page}&pageSize=${pageSize}`,
        httpOptions,
      )
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'NOTE | get_user_notes_page | catchError | errorMessage: ' + errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  get_note(note_id: any): any {
    this.logger.info('NOTE | get_note | note_id: ' + note_id)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(`${Backend.HOST_CONTAINER + Backend.NOTE + note_id + '/'}`, httpOptions)
      .pipe(
        map((res: any) => {
          return { success: true, res: res }
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('NOTE | get_note | catchError | errorMessage: ' + errorMessage)
          return of({ success: false, res: errorMessage })
        }),
      )
  }
}
